import { retrieveMethod } from "./resource";
const resource = "keys";
export const retrieve = (client, apiKey, request) => retrieveMethod({
    resource,
    client,
})(apiKey, request);
export const usage = (client, apiKey, request) => retrieveMethod({
    resource,
    client,
    action: "usage",
})(apiKey, request);
